import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
// ===== ID SCHEMAS =====
const LocaleIdSchema = createIdSchema('locale');
const LocaleTableSelectSchema = createStrictSchema()({
    id: LocaleIdSchema,
    code: z.string(),
    name: z.string(),
    nameNative: z.string(),
    isDefault: z.boolean(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const LocaleInfoSchema = LocaleTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API (json safe date string)
});
const LocaleInfoIdSchema = LocaleIdSchema;
export { LocaleInfoIdSchema, LocaleInfoSchema, LocaleTableSelectSchema };
//# sourceMappingURL=locale.types.js.map